import {shallowEqual, useSelector} from 'react-redux';
import XDate from 'xdate';
import * as utils from '~/common/utils';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {
  selectDeliverCardNow,
  selectDeliveryCardDateTime,
  selectDeliveryCardTimezone,
} from '~/common/fabric/reducers/review/selectors';
import {getEventId} from '~/common/fabric/reducers/eviteEvent/selectors';
import {useCartEndpoints} from '~/CreateFabricInvitation/hooks/useCartEndpoints';
import {EventThumbnail} from '~library/molecules/EventThumbnail';
import './Card.sass';

export const Card = () => {
  const eventId = useSelector(getEventId);
  const eviteEvent = useSelector((state) => state.eviteEvent);
  const deliverCardNow = useSelector(selectDeliverCardNow);
  const deliveryCardDateTime = useSelector(selectDeliveryCardDateTime);
  const deliveryCardTimeZone = useSelector(selectDeliveryCardTimezone);
  const guests = useSelector((state) => state.guests, shallowEqual);
  const {checkoutData} = useCartEndpoints(eventId);
  const guestsAdded = checkoutData?.guestsAdded || guests?.guests.count;

  const sendLaterTimezone = evite.features.isEnabled('greeting_card_send_later_timezone', false);

  let date;
  if (deliverCardNow) {
    date = XDate().toString('MMM d, yyyy');
  } else {
    date = sendLaterTimezone
      ? `${XDate(deliveryCardDateTime).toString("MMM d, yyyy 'at' h:mm TT")} ${
          deliveryCardTimeZone.known_timezone_abbr
        }`
      : XDate(deliveryCardDateTime).toString('MMM d, yyyy');
  }

  return (
    <div className="success-page__card">
      <EventThumbnail eventId={eviteEvent.id} alt="card" loading="lazy" />
      <div className="success-page__card__info">
        <div>
          <Typography variant="label2" color="charcoal">
            Send date:
          </Typography>
          <Typography variant="paragraph2" color="charcoal">
            {date}
          </Typography>
        </div>
        <div>
          <Typography variant="label2" color="charcoal">
            Sending to:
          </Typography>
          <Typography variant="paragraph2" color="charcoal">
            {utils.pluralize('recipient', guestsAdded || 0)}
          </Typography>
        </div>
        <div>
          <a href={`/card-overview/${eviteEvent.id}`}>
            <Button variant="link" data-qa-id="view-card-overview">
              View card overview
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};
